export function SocialPromo() {
  return null; // Remove the SocialPromo component as it is no longer needed.
}